/**
 *  Storing all action type constants.
 *  Best practice to set action types using const rather than hard coded names
 */
/**
 *  user profile
 */
export const RECEIVED_PROFILE_INFO = 'Received user profile'
export const START_FETCHING_PROFILE = '[Thunk] Start fetching user profile'
export const ERROR_ON_GETTING_PROFILE = 'Failed to get user profile'
export const CHANGE_TAB_PAGE = 'Changing tab, to show different page'
export const RESET_PROFILE = 'Clear user profile'
export const SHOW_ACCOUNT_SETTING = 'Show account setting page'

/**
 *  material usage panel
 */
export const START_FETCHING_MATERIAL_USAGE = '[Thunk] Start fetching material usage data'
export const RECEIVED_MATERIAL_USAGE_INFO = 'Received material usage info'
export const ERROR_ON_GETTING_MATERIAL_USAGE = 'Failed to get material usage info'

/**
 *  printer status panel
 */
export const START_FETCHING_PRINTER_LIST = '[Thunk] Start fetching printer list'
export const RECEIVED_PRINTER_LIST = 'Received printer list'
export const ERROR_ON_GETTING_PRINTER_LIST = 'Failed to get printer list'
export const UPDATE_PRINTER_STATE = 'Update printer\'s state'
export const UPDATE_TOGGLE_LIST_OF_PRINTER_STATUS = 'Toggle printer card'

/**
 *  printed models panel
 */
export const START_FETCHING_PRINTED_MODELS = '[Thunk] Start fetching historical prints'
export const RECEIVED_PRINTED_MODELS_INFO_OVERRIDE = 'Received prints, overwrite whole list'
export const RECEIVED_PRINTED_MODELS_INFO_APPEND = 'Received prints, append to the end'
export const ERROR_ON_GETTING_PRINTED_MODELS = 'Failed to get historical prints'
export const UPDATE_TOGGLE_LIST_OF_PRINT_ITEMS = 'Updated toggles of prints cards'
export const TOGGLE_PRINT_FILTER = 'Toggled print filters'
export const CHANGE_DATE_FILTER_START = 'Changed date filter: start date'
export const CHANGE_DATE_FILTER_END = 'Changed date filter: end date'
export const CHANGE_MODEL_NAME_FILTER = 'Changed model name filter'

/**
 * printers panel
 */
export const START_FETCHING_MATERIAL_USAGE_OF_PRINTER = '[Thunk] Start fetching material usage info of printer'
export const RECEIVED_MATERIAL_USAGE_OF_PRINTER = 'Received material usage info of printer'
export const ERROR_ON_GETTING_MATERIAL_USAGE_OF_PRINTER = 'Failed to get material usage info of printer'
export const RECEIVED_PRINTS_NUMBER = 'Received total number of prints on the printer'
export const ERROR_ON_GETTING_PRINTS_NUMBER = 'Failed to get total number of prints on the machine'

/**
 * Subscription
 */
export const START_FETCHING_SUBSCRIPTION_LIST = '[Thunk] Start fetching subscription status'
export const RECEIVED_SUBSCRIPTION_LIST = 'Received subscription status'
export const ERROR_ON_GETTING_SUBSCRIPTION_LIST = 'Failed to get subscription status'
export const INTERVAL_CHOSEN = 'Chose plan span'
export const TIER_CHOSEN = 'Chose plan tier'
export const CANCEL_SUBSCRIPTION = '[Thunk] Cancelling subscription'
export const CANCEL_SUBSCRIPTION_SUCCESSFULLY = 'Cancelled subscription successfully'
export const CANCEL_SUBSCRIPTION_FAILED = 'Failed to cancel subscription'
export const START_FETCHING_INVOICE_LIST = '[Thunk] Start fetching invoice list'
export const RECEIVED_INVOICE_LIST = 'Received invoice list'
export const ERROR_ON_GETTING_INVOICE_LIST = 'Failed to get invoice list'

/**
 * Email subscription
 */
export const START_FETCHING_EMAIL_SUBSCRIBE_STATUS = '[Thunk] Start fetching email subscribe status'
export const RECEIVED_EMAIL_SUBSCRIBE_STATUS = 'Received email subscribe status'
export const START_TOGGLE_PRINT_STATUS_EMAIL = '[Thunk] Start toggle print status email';
export const TOGGLE_PRINT_STATUS_EMAIL_SUCCESSFULLY = 'Toggle print status email successfully';
export const TOGGLE_PRINT_STATUS_EMAIL_FAILED = 'Toggle print status email failed';

/**
 * Lightbox control action types
 */
export const OPEN_LIGHTBOX = 'Opened Lightbox of given src'
export const CLOSE_LIGHTBOX = 'Closed Lightbox'

/**
 * print record panel
 */
export const SEARCH_PRINT_RECORDS_BY_EMAIL = 'Search print records by email'
export const CHANGE_SEARCH_EMAIL = 'Change search email'
export const CLEAR_PRINTED_MODELS_INFO = 'Clear model info list'
export const INIT_LOADING_AND_HASMORE_STATUS = 'Init loding and hasMore status'
export const ERROR_ON_GETTING_PRINT_RECORD = 'Failed to get print record'
export const CLEAR_ERROR = 'Clear error' 
export const START_SEARCHING_PRINT_RECORDS = 'Start searching print records'

/**
 * print record sharing
 */
export const START_FETCHING_PRINT_RECORD_SHARING_STATUS = '[Thunk] Start fetching print record sharing status'
export const RECEIVED_PRINT_RECORD_SHARING_STATUS = 'Received print record sharing status'
export const START_TOGGLE_PRINT_RECORD_SHARING = '[Thunk] Start toggle print record sharing status';
export const TOGGLE_PRINT_RECORD_SHARING_SUCCESSFULLY = 'Toggle print record sharing status successfully';
export const TOGGLE_PRINT_RECORD_SHARING_FAILED = 'Toggle print record sharing status failed';




// WEBPACK FOOTER //
// ./src/actions/types.js